<template>
  <SfRating :id="id" :data-testid="`${id}-rating`" :value="value" :max="max" />
</template>

<script setup lang="ts">
import type { RatingProps } from '~/components/ui/Rating/types';

defineProps<RatingProps>();
</script>
